import { SidePanelStatus } from "@nova/component-side-panel-tab-container"
import { JobStatusType, JobTypes } from "@nova/constants"
import { dateFromNumber } from "@nova/serializer/src/client/util"
import { useAppSelector } from "integrations/redux/hooks"
import { selectPDFById } from "plugins/PDFv2/PDFSlice"
import { StatusAndProgressData } from "../generics/GenericLayerListItemProgress"
import { useJobProgress } from "../useJobProgress"

export function usePDFStatusAndProgress(id: string): StatusAndProgressData {
    const job = useAppSelector(selectPDFById(id))
    const jobStatus = job.status
    const jobLoading = jobStatus !== JobStatusType.COMPLETED && jobStatus !== JobStatusType.FAILED
    const status = jobLoading
        ? SidePanelStatus.loading
        : jobStatus === JobStatusType.FAILED
          ? SidePanelStatus.failed
          : undefined
    const progress = useJobProgress({ job, type: JobTypes.PDF })
    const createdAtDate = dateFromNumber(job.createdAt)
    switch (status) {
        case SidePanelStatus.loading: {
            return {
                status,
                progress,
                createdAtDate,
            }
        }
    }
    return {
        status,
    }
}
